import {ChangeDetectionStrategy, Component, input, InputSignal} from '@angular/core';
import {CommonModule} from '@angular/common';

import {DrawingModel} from 'shared/models';
import {PlayerUi} from '../player-ui/player-ui';

@Component({
  selector: 'players-ui',
  standalone: true,
  imports: [CommonModule, PlayerUi],
  templateUrl: './players-ui.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlayersUi {
  drawings: InputSignal<DrawingModel[]> = input.required<DrawingModel[]>();
}
